export default __webpack_public_path__ + "static/media/Group 160.fd670bc1.png";